//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class WatchdogUrlConstants
{
	public static watchdogIdVariable: string = `$watchdogId`;
	public static unsubscribeTokenVariable: string = `$unsubscribeToken`;
	public static watchdogDetailUrlTemplate: string = `/Watchdogs/Detail/$watchdogId`;
	public static watchdogDetailOverviewUrlTemplate: string = `/Watchdogs/Detail/Overview/$watchdogId`;
	public static watchdogsUrl: string = `/Watchdogs`;
	public static disableWatchdogNotificationsPostUrlTemplate: string = `/api/Watchdogs/DisableNotificationPost?unsubscribeToken=$unsubscribeToken`;
	public static disableWatchdogNotificationsGetUrlTemplate: string = `/api/Watchdogs/DisableNotificationGet?unsubscribeToken=$unsubscribeToken`;
}
